import Dialog from './components/Dialog';
import DownloadIcal from "./components/DownloadIcal";
import EventHeartbeat from "./components/EventHeartbeat";

document.addEventListener( 'DOMContentLoaded', () => {
  new Dialog( 'event-calendar-dialog', 'event-calendar-button' );
  new Dialog( 'event-apply-dialog', 'event-apply-button' );
  new Dialog( 'event-share-dialog', 'event-share-button' );
  new Dialog( 'event-calendar-dialog', 'event-cta-calendar-button' );
  new Dialog( 'event-apply-dialog', 'event-cta-apply-button' );
  new Dialog( 'event-share-dialog', 'event-cta-share-button' );

  new DownloadIcal( 'event-download-ical-button' );
  new EventHeartbeat();

  Array.from( document.getElementsByClassName( 'gchoice_other_control' ) )?.forEach( (input) => input.onfocus = () => input.value = '' );
} );
